const namespaced = true;

const state = {
	isOpenDialog: false,
};

const getters = {
	isOpenDialog(state) {
		return state.isOpenDialog;
	},
};

const mutations = {
	openDialog(state) {
		state.isOpenDialog = true;
	},
	closeDialog(state) {
		state.isOpenDialog = false;
	},
};

const actions = {
	openDialog({ commit }) {
		commit('openDialog');
	},
	closeDialog({ commit }) {
		commit('closeDialog');
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
